import { uploadMediaAction } from 'store/actions/media.action'

export const uploadFileService =
  (selectedModel, setSelectedModel, setLoading, files, item, single = false) =>
  async (dispatch) => {
    let tempModel = structuredClone(selectedModel)
    setLoading(true)
    for (const file of files) {
      const formData = new FormData()
      formData.append('media', file)
      await dispatch(
        uploadMediaAction(formData, false, (url) => {
          if (tempModel.args[item].value?.length && !single)
            tempModel.args[item].value = tempModel.args[item].value + ',' + url
          else tempModel.args[item].value = url
        })
      )
    }
    setLoading(false)
    setSelectedModel(tempModel)
  }

export const uploadMaskService =
  (selectedModel, setSelectedModel, setEmptyFieldsExist, file, item) => async (dispatch) => {
    const formData = new FormData()
    formData.append('media', file, 'output.png')
    let tempModel = structuredClone(selectedModel)

    await dispatch(
      uploadMediaAction(
        formData,
        false,
        (url) => {
          tempModel.args[item].value = url
        },
        null,
        ['mask']
      )
    )
    const argsArray = Object.keys(tempModel.args)
    const emptyFieldData = argsArray.filter(
      (item) =>
        tempModel?.args[item].optional === false && (tempModel?.args[item].value === '' || !tempModel?.args[item].value)
    )
    setSelectedModel(tempModel)
    setEmptyFieldsExist(emptyFieldData)
  }

export const removeImageService = (selectedModel, setSelectedModel, itemKey, index = null) => {
  let tempModel = structuredClone(selectedModel)

  if (index == null) tempModel.args[itemKey].value = ''
  else {
    let valueList = tempModel.args[itemKey].value.split(',')
    valueList.splice(index, 1)
    tempModel.args[itemKey].value = valueList.join(',')
  }

  setSelectedModel(tempModel)
}

export const downloadFile = async (url) => {
  try {
    const response = await fetch(url, { mode: 'cors' })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const blob = await response.blob()
    const file = new File([blob], `uploaded-file.jpg`, { type: blob.type })
    return file
  } catch (error) {
    console.error('Error downloading the file:', error)
  }
}
